import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type Cart } from '../../../../../../src/types/Cart';

/**
 * @deprecated PairingParams interface deprecated in favor of PairingMutationParams
 *
 * We cannot always use PairingMutationParams. One case is when we want to "duplicate"
 * a bundle. We do not have the original removed reason, so we have to use PairingParams
 * in that case
 */
export interface PairingParams {
  pairing: {
    id: number;
    ingredients: number[];
  };
}

interface PairingMutationParams {
  pairing: {
    id: number;
    modifications: Array<{
      removed: number;
      reason_id: number;
    }>;
  };
}

interface ProductParams {
  product_id: number;
}

type Params = PairingParams | ProductParams | PairingMutationParams;

export function patchCartRequest(params: Params) {
  return send<Cart>({
    path: `/api/v2/customers/self/cart/`,
    method: 'PATCH',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: params,
  });
}
